(() => {
    const dropdowns = document.querySelectorAll('.dropdown')

    if(dropdowns.length < 1 || !dropdowns) return

    window.addEventListener('click',() => {
        dropdowns.forEach((dropdown) => {
            dropdown.querySelector('input').checked = false
        })
    }, false)

    dropdowns.forEach((dropdown) => {

        const options = dropdown.querySelectorAll('.option')

        let dropLabel = dropdown.querySelector('label span')
        let dropInput = dropdown.querySelector('input')

        options.forEach(option => {
            const input = option.querySelector('input')
            const label = option.querySelector('label')

            input.addEventListener('change', () => {
                console.log('changed')
                console.log(label.innerText)
                dropLabel.innerText = label.innerText
                dropInput.checked = false
            })
        })

        dropdown.addEventListener('click', (e) => {
            e.stopPropagation();
        }, false)
    })
})()
